/**
 * External dependencies
 */
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@art-of-hospitality-solutions-llc/ui-kit/components/dialog';

/**
 * Internal dependencies
 */
import Loader from '@Components/Loader';
import { useCacheEntry } from '@Hooks/useCache';

interface CacheInspectDialogProps {
  cacheKey: string | null;
  onOpenChange: (open: boolean) => void;
}

export default function CacheInspectDialog({
  cacheKey,
  onOpenChange,
}: CacheInspectDialogProps) {
  const { data: entry, status } = useCacheEntry(cacheKey);

  return (
    <Dialog open={cacheKey !== null} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle>Cache entry</DialogTitle>
        </DialogHeader>
        {cacheKey && (
          <div className="space-y-3">
            <div className="font-mono text-xs break-all text-zinc-500">
              {cacheKey}
            </div>
            {status === 'pending' ? (
              <Loader size="md" />
            ) : status === 'error' || !entry ? (
              <div className="text-sm text-red-600">
                Failed to load entry (it may have just expired).
              </div>
            ) : (
              <pre className="max-h-[60vh] overflow-auto rounded bg-zinc-50 p-3 text-xs">
                {JSON.stringify(entry.value, null, 2)}
              </pre>
            )}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
